import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import PageHeader from "@/components/PageHeader";
import VehicleDueAlert from "@/components/VehicleDueAlert";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import VehicleMaster from "@/components/vehicle/VehicleMaster";
import VehicleServices from "@/components/vehicle/VehicleServices";
import VehicleFuel from "@/components/vehicle/VehicleFuel";
import VehicleReport from "@/components/vehicle/VehicleReport";
import { toast } from "sonner";

export default function Vehicles() {
  const { user } = useAuth();
  const [vehicles, setVehicles] = useState([]);
  const load = () => api.get("/vehicles").then((r) => setVehicles(r.data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-5">
      <PageHeader title="Perawatan Kendaraan" subtitle="Master kendaraan, service, pengisian BBM & laporan biaya" />
      <VehicleDueAlert key={vehicles.length + JSON.stringify(vehicles.map((v) => v.tgl_pajak + v.tgl_stnk))} />
      <Tabs defaultValue={user?.role === "site_admin" ? "bbm" : "master"}>
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="master" data-testid="veh-tab-master">Master Kendaraan</TabsTrigger>
          <TabsTrigger value="service" data-testid="veh-tab-service">Perawatan & Service</TabsTrigger>
          <TabsTrigger value="bbm" data-testid="veh-tab-bbm">Pengisian BBM</TabsTrigger>
          <TabsTrigger value="laporan" data-testid="veh-tab-laporan">Laporan</TabsTrigger>
        </TabsList>
        <TabsContent value="master"><VehicleMaster vehicles={vehicles} reload={load} /></TabsContent>
        <TabsContent value="service"><VehicleServices vehicles={vehicles} /></TabsContent>
        <TabsContent value="bbm"><VehicleFuel vehicles={vehicles} /></TabsContent>
        <TabsContent value="laporan"><VehicleReport vehicles={vehicles} /></TabsContent>
      </Tabs>
    </div>
  );
}
